/**
 * @import {CommentCreatedEvent} from 'acng/ts/comment';
 */
import {GlobalContext} from '@acng/frontend-relativity';

/**
 * @type {Global<CommentCreatedEvent | null>}
 */
export const ctxCreatedComment = GlobalContext(null);
